import {
  Outlet,
  Navigate,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import { useSelector } from "react-redux";

import { selectIsAuthenticated } from "@/redux/authentication/selectors.js";
import { useResponsive } from "@/shared/hooks/useBreakpoints";
import BrandingPanel from "./BrandingPanel";
import AlternateAction from "./AlternateAction";

import "./styles.css";

const OnboardingLayout = () => {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const { isDesktopOrLaptop } = useResponsive();
  const isAdminInviteRegister =
    pathname === "/register" && searchParams.get("admin_invite") === "true";

  if (isAuthenticated) {
    return <Navigate to={searchParams.get("redirect_to") ?? "/"} />;
  }

  return (
    <div className="onboarding-layout flex">
      {isDesktopOrLaptop && <BrandingPanel />}
      <div className="onboarding-layout__main flex flex-col flex-1">
        <main className="onboarding-layout__content flex flex-1 items-start justify-center">
          <div className="onboarding-layout__form-card flex flex-col self-center gap-200">
            <Outlet />

            {!isAdminInviteRegister && <AlternateAction />}
          </div>
        </main>
      </div>
    </div>
  );
};

export default OnboardingLayout;
